import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

export const NavContainer = styled.div`
  max-width: 1280px;
  margin: auto;
`;

export const Ul = styled.ul`
  padding: 0px;
  margin: 0px;
  list-style: none;
  display: flex;
`;

export const LiWrapper = styled.div`
  margin: 0 10px;
`;

export const Li = styled.li`
  display: inline;
  margin-right: 10px;
  border-bottom: ${props => (props.current ? '2px solid;' : '0px solid;')};

  :hover {
    color: #6d6d6d;
    border-bottom: 2px solid;
  }
`;

export const Link = styled(RouterLink)`
  padding: 2px 0px;
  display: inline-block;
  color: #333;
  text-decoration: none;
`;

export const SearchBoxContainer = styled.div`
  button {
    border: none;
    color: white;
    background-color: #3b85f0;
    padding: 8px 12px;
    border-radius: 25px;
    margin: 0 16px;
  }

  ._spectrum-ClearButton_7a745 {
    display: none;
  }
`;
